<template>
  <footer class="global-footer">
    <div class="w-1200 mx-auto fz-12 copyright">
      <span style="margin-right: 23px;">{{ config.copyright }} </span>
      <span class="beian">
        <img src="https://co-image.qichacha.com/upload/chacha/img/20191206/1575615736779577.png" alt="">
         &nbsp;
         {{ config.beian }}
        </span>
    </div>
  </footer>

</template>

<script>
export default {};

</script>

<style scoped lang="scss">

.global-footer {
  width: 100%;
  height: 66px;
  background-color: #232426;
  color: #fff;

  .copyright {
    height: 100%;
    color: rgba(255, 255, 255, .6);
    display: flex;
    justify-content: center;
    align-items: center;

    .beian {
      display: flex;
      align-items: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue